// SOCKET
export const SOCKET_EMIT = 'SOCKET:EMIT';
export const SOCKET_SUBSCRIBE = 'SOCKET:SUBSCRIBE';

// SESSION
export const SESSION_FETCH = 'SESSION:FETCH';
export const SESSION_FETCH_SUCCESS = 'SESSION:FETCH_SUCCESS';
export const SESSION_FETCH_FAIL = 'SESSION:FETCH_FAIL';
export const VERIFY_ACCOUNT_FETCH = 'VERIFY:ACCOUNT_FETCH';
export const VERIFY_ACCOUNT_FETCH_SUCCESS = 'VERIFY:ACCOUNT_FETCH_SUCCESS';
export const VERIFY_ACCOUNT_FETCH_FAIL = 'VERIFY:ACCOUNT_FETCH_FAIL';
export const USER_SETTING_WRITE = 'USER:SETTING_WRITE';
export const USER_SETTING_WRITE_SUCCESS = 'USER:SETTING_WRITE_SUCCESS';
export const USER_SETTING_WRITE_FAIL = 'USER:SETTING_WRITE_FAIL';

// APP
export const DESKTOP_APP_FLAG_SET = 'APP:DESKTOP_APP_FLAG_SET';
export const DESKTOP_APP_FLAG_GET = 'APP:DESKTOP_APP_FLAG_GET';
export const SHOW_ALL_PACKAGES_FLAG_SET = 'APP:SHOW_ALL_PACKAGES_FLAG_SET';
export const UPGRADE_POPUP_FLAG_SET = 'APP:UPGRADE_POPUP_FLAG_SET';
export const PENDING_TRIGGER_CHECKOUT_FLAG_SET = 'APP:PENDING_TRIGGER_CHECKOUT_FLAG_SET';
export const COUPON_ID_PROVIDED_FLAG_SET = 'APP:COUPON_ID_PROVIDED_FLAG_SET';
export const PERPETUAL_APP_FLAG_SET = 'APP:PERPETUAL_APP_FLAG_SET';
export const DESKTOP_TRIAL_FLAG_SET = 'APP:DESKTOP_TRIAL_FLAG_SET';
export const DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET = 'APP:DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET';
export const RENEWAL_POPUP_SHOWN = 'APP:RENEWAL_POPUP_SHOWN';

// COUPON
export const COUPON_FETCH = 'COUPON:FETCH';
export const COUPON_FETCH_SUCCESS = 'COUPON:FETCH:SUCCESS';
export const COUPON_FETCH_FAIL = 'COUPON:FETCH:FAIL';
export const COUPON_APPLY_WITHOUT_VALIDATION = 'COUPON:APPLY_WITHOUT_VALIDATION:SUCCESS';
export const COUPON_CHANGE_TYPE = 'COUPON:CHANGE_TYPE:SUCCESS';
export const COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE = 'COUPON:COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE:SUCCESS';

// COMPANIES
export const COMPANIES_GET_ACTIVE_COMPANY_ID = 'COMPANIES:GET_ACTIVE_COMPANY_ID';
export const COMPANIES_SET = 'COMPANIES:SET';
export const COMPANIES_VALIDATE = 'COMPANIES:VALIDATE';
export const COMPANIES_VALIDATE_SUCCESS = 'COMPANIES:VALIDATE_SUCCESS';
export const COMPANIES_VALIDATE_FAIL = 'COMPANIES:VALIDATE_FAIL';
export const COMPANIES_ADD = 'COMPANIES:ADD';
export const COMPANIES_ADD_SUCCESS = 'COMPANIES:ADD_SUCCESS';
export const COMPANIES_ADD_FAIL = 'COMPANIES:ADD_FAIL';
export const COMPANIES_REMOVE = 'COMPANIES:REMOVE';
export const COMPANIES_REMOVE_SUCCESS = 'COMPANIES:REMOVE_SUCCESS';
export const COMPANIES_REMOVE_FAIL = 'COMPANIES:REMOVE_FAIL';
export const COMPANIES_CHANGE = 'COMPANIES:CHANGE';
export const COMPANIES_CHANGED = 'COMPANIES:CHANGED';
export const COMPANIES_USER_ADD = 'COMPANIES:USER:ADD';
export const COMPANIES_USER_ADD_SUCCESS = 'COMPANIES:USER:ADD_SUCCESS';
export const COMPANIES_USER_ADD_FAIL = 'COMPANIES:USER:ADD_FAIL';
export const COMPANIES_ESTIMATE_USER_ADD = 'COMPANIES:ESTIMATE:USER:ADD';
export const COMPANIES_ESTIMATE_USER_ADD_SUCCESS = 'COMPANIES:ESTIMATE:USER:ADD_SUCCESS';
export const COMPANIES_ESTIMATE_USER_ADD_FAIL = 'COMPANIES:ESTIMATE:USER:ADD_FAIL';
export const COMPANIES_ESTIMATE_SEAT = 'COMPANIES:ESTIMATE:SEAT';
export const COMPANIES_ESTIMATE_SEAT_SUCCESS = 'COMPANIES:ESTIMATE:SEAT:SUCCESS';
export const COMPANIES_ESTIMATE_SEAT_FAIL = 'COMPANIES:ESTIMATE:SEAT:FAIL';
export const COMPANIES_PURCHASE_SEAT = 'COMPANIES:PURCHASE:SEAT';
export const COMPANIES_PURCHASE_SEAT_SUCCESS = 'COMPANIES:PURCHASE:SEAT:SUCCESS';
export const COMPANIES_PURCHASE_SEAT_FAIL = 'COMPANIES:PURCHASE:SEAT:FAIL';
export const COMPANIES_USER_UPDATE = 'COMPANIES:USER:UPDATE';
export const COMPANIES_USER_UPDATE_SUCCESS = 'COMPANIES:USER:UPDATE_SUCCESS';
export const COMPANIES_USER_UPDATE_FAIL = 'COMPANIES:USER:UPDATE_FAIL';
export const COMPANIES_USERS_REDUCE = 'COMPANIES:USER:REDUCE';
export const COMPANIES_USERS_REDUCE_SUCCESS = 'COMPANIES:USER:REDUCE_SUCCESS';
export const COMPANIES_USERS_REDUCE_FAIL = 'COMPANIES:USER:REDUCE_FAIL';
export const COMPANIES_ESTIMATE_USER_UPDATE = 'COMPANIES:ESTIMATE:USER:UPDATE';
export const COMPANIES_ESTIMATE_USER_UPDATE_SUCCESS = 'COMPANIES:ESTIMATE:USER:UPDATE_SUCCESS';
export const COMPANIES_ESTIMATE_USER_UPDATE_FAIL = 'COMPANIES:ESTIMATE:USER:UPDATE_FAIL';
export const COMPANIES_USER_DELETE = 'COMPANIES:USER:DELETE';
export const COMPANIES_USER_DELETE_SUCCESS = 'COMPANIES:USER:DELETE_SUCCESS';
export const COMPANIES_USER_DELETE_FAIL = 'COMPANIES:USER:DELETE_FAIL';
export const COMPANIES_ESTIMATE_USER_DELETE = 'COMPANIES:ESTIMATE:USER:DELETE';
export const COMPANIES_ESTIMATE_USER_DELETE_SUCCESS = 'COMPANIES:ESTIMATE:USER:DELETE_SUCCESS';
export const COMPANIES_ESTIMATE_USER_DELETE_FAIL = 'COMPANIES:ESTIMATE:USER:DELETE_FAIL';
export const COMPANIES_UPDATE = 'COMPANIES:UPDATE';
export const COMPANIES_UPDATE_SUCCESS = 'COMPANIES:UPDATE_SUCCESS';
export const COMPANIES_UPDATE_FAIL = 'COMPANIES:UPDATE_FAIL';

export const COMPANIES_INVITE_USER_ADD = 'COMPANIES:INVITE_USER:ADD';
export const COMPANIES_INVITE_USER_UPDATE = 'COMPANIES:INVITE_USER:UPDATE';
export const COMPANIES_INVITE_USER_REMOVE = 'COMPANIES:INVITE_USER:REMOVE';
export const COMPANIES_INVITE_USER_MESSAGE_SET = 'COMPANIES:INVITE_USER:MESSAGE:SET';

export const COMPANIES_INVITE_USER_CLEAR_USERS = 'COMPANIES:INVITE_USER:USERS:CLEAR';
export const COMPANIES_INVITE_USER_CLEAR_MESSAGE = 'COMPANIES:INVITE_USER:MESSAGE:CLEAR';

export const COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS = 'COMPANIES:CURRENT_MEMBER_ADDON:GET';
export const COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS = 'COMPANIES:CURRENT_MEMBER_ADDON:GET_SUCCESS';
export const COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL = 'COMPANIES:CURRENT_MEMBER_ADDON:GET_FAIL';
export const COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS = 'COMPANIES:CURRENT_MEMBER_ADDON:CLEAR';

export const COMPANIES_CONTACT_SALES = 'COMPANIES:CONTACT_SALES';
export const COMPANIES_CONTACT_SALES_SUCCESS = 'COMPANIES:CONTACT_SALES:SUCCESS';
export const COMPANIES_CONTACT_SALES_FAIL = 'COMPANIES:CONTACT_SALES:FAIL';

export const COMPANIES_UPDATE_USER_PHOTO = 'COMPANIES:UPDATE_USER_PHOTO';
export const COMPANIES_UPDATE_USER_PHOTO_SUCCESS = 'COMPANIES:UPDATE_USER_PHOTO:SUCCESS';
export const COMPANIES_UPDATE_USER_PHOTO_FAIL = 'COMPANIES:UPDATE_USER_PHOTO:FAIL';

export const USER_UPDATE = 'USER:UPDATE';
export const USER_UPDATE_SUCCESS = 'USER:UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER:UPDATE_FAIL';

export const USER_EXTERNAL_ID_UPDATE = 'USER:EXTERNAL_ID:UPDATE';
export const USER_EXTERNAL_ID_UPDATE_SUCCESS = 'USER:EXTERNAL_ID:UPDATE_SUCCESS';
export const USER_EXTERNAL_ID_UPDATE_FAIL = 'USER:EXTERNAL_ID:UPDATE_FAIL';
export const USER_EXTERNAL_ID_STATE_CLEAR = 'USER:EXTERNAL_ID:STATE_CLEAR';

export const USER_REGION_FETCH = 'USER_REGION:FETCH';
export const USER_REGION_FETCH_SUCCESS = 'USER_REGION:FETCH_SUCCESS';
export const USER_REGION_FETCH_FAIL = 'USER_REGION:FETCH_FAIL';

export const ADDON_GET_DETAILS = 'ADDON:GET_DETAILS';
export const ADDON_GET_DETAILS_SUCCESS = 'ADDON:GET_DETAILS_SUCCESS';
export const ADDON_GET_DETAILS_FAIL = 'ADDON:GET_DETAILS_FAIL';

export const UPCOMING_INVOICE_GET_ESTIMATE = 'UPCOMING_INVOICE:GET_ESTIMATE';
export const UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS = 'UPCOMING_INVOICE:GET_ESTIMATE_SUCCESS';
export const UPCOMING_INVOICE_GET_ESTIMATE_FAIL = 'UPCOMING_INVOICE:GET_ESTIMATE_FAIL';

export const SUBSCRIPTION_GET_ESTIMATE = 'SUBSCRIPTION:GET_ESTIMATE';
export const SUBSCRIPTION_GET_ESTIMATE_SUCCESS = 'SUBSCRIPTION:GET_ESTIMATE_SUCCESS';
export const SUBSCRIPTION_GET_ESTIMATE_FAIL = 'SUBSCRIPTION:GET_ESTIMATE_FAIL';

export const SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN = 'SUBSCRIPTION:GET_ESTIMATE_ACTIVE_PLAN';
export const SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS = 'SUBSCRIPTION:GET_ESTIMATE_ACTIVE_PLAN_SUCCESS';
export const SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL = 'SUBSCRIPTION:GET_ESTIMATE_ACTIVE_PLAN_FAIL';

export const ACCOUNT_EMAIL_UPDATE = 'ACCOUNT:EMAIL:UPDATE';
export const ACCOUNT_EMAIL_UPDATE_SUCCESS = 'ACCOUNT:EMAIL:UPDATE_SUCCESS';
export const ACCOUNT_EMAIL_UPDATE_FAIL = 'ACCOUNT:EMAIL:UPDATE_FAIL';

export const ACCOUNT_NAME_UPDATE = 'ACCOUNT:NAME:UPDATE';
export const ACCOUNT_NAME_UPDATE_SUCCESS = 'ACCOUNT:NAME:UPDATE_SUCCESS';
export const ACCOUNT_NAME_UPDATE_FAIL = 'ACCOUNT:NAME:UPDATE_FAIL';

export const ACCOUNT_PASSWORD_UPDATE = 'ACCOUNT:PASSWORD:UPDATE';
export const ACCOUNT_PASSWORD_UPDATE_SUCCESS = 'ACCOUNT:PASSWORD:UPDATE_SUCCESS';
export const ACCOUNT_PASSWORD_UPDATE_FAIL = 'ACCOUNT:PASSWORD:UPDATE_FAIL';

export const ACCOUNT_PASSWORD_RESET = 'ACCOUNT:PASSWORD:RESET';
export const ACCOUNT_PASSWORD_RESET_SUCCESS = 'ACCOUNT:PASSWORD:RESET_SUCCESS';
export const ACCOUNT_PASSWORD_RESET_FAIL = 'ACCOUNT:PASSWORD:RESET_FAIL';

export const ACCOUNT_CHECK_CREDENTIALS = 'ACCOUNT:CHECK_CREDENTIALS';
export const ACCOUNT_CHECK_CREDENTIALS_SUCCESS = 'ACCOUNT:CHECK_CREDENTIALS_SUCCESS';
export const ACCOUNT_CHECK_CREDENTIALS_FAIL = 'ACCOUNT:CHECK_CREDENTIALS_FAIL';

export const CRS_CHECK_CREDENTIALS = 'CRS:CHECK_CREDENTIALS';
export const CRS_CHECK_CREDENTIALS_SUCCESS = 'CRS:CHECK_CREDENTIALS_SUCCESS';
export const CRS_CHECK_CREDENTIALS_FAIL = 'CRS:CHECK_CREDENTIALS_FAIL';
export const CRS_CLEAR_CREDENTIALS = 'CRS:CLEAR_CREDENTIALS';
export const CRS_SAVE_TAKEOVER_CREDENTIALS = 'CRS:SAVE_TAKEOVER_CREDENTIALS';

export const CRS_USAGE_UPDATE = 'CRS:NAME:UPDATE';
export const CRS_USAGE_UPDATE_SUCCESS = 'CRS:NAME:UPDATE_SUCCESS';
export const CRS_USAGE_UPDATE_FAIL = 'CRS:NAME:UPDATE_FAIL';

export const DISCOUNT_CLEAR_APPLIED = 'DISCOUNT:CLEAR_APPLIED';
export const DISCOUNT_APPLY_MAGIX = 'DISCOUNT:APPLY_MAGIX';
export const DISCOUNT_APPLY_COUPON_SET_ID = 'DISCOUNT:APPLY_COUPON_SET_ID';

export const REDUCE_USERS_API_ERROR_STATE_SET = 'USER:REDUCE_API_ERROR_STATE:SET';
export const REDUCE_USERS_API_ERROR_STATE_CLEAR = 'USER:REDUCE_API_ERROR_STATE:CLEAR';

export const SET_USER_SUPPLIED_PROMO_CODE = 'DISCOUNT:SET_USER_SUPPLIED_PROMO_CODE';

export const COMPANIES_CREATE_CHARGEBEE_SESSION = 'COMPANIES:CREATE:CHARGEBEE:SESSION';
export const COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS = 'COMPANIES:CREATE:CHARGEBEE:SESSION:SUCCESS';
export const COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL = 'COMPANIES:CREATE:CHARGEBEE:SESSION:FAIL';
export const COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION = 'COMPANIES:CREATE:CHARGEBEE:SUBSCRIPTION';
export const COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS = 'COMPANIES:CREATE:CHARGEBEE:SUBSCRIPTION:SUCCESS';
export const COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL = 'COMPANIES:CREATE:CHARGEBEE:SUBSCRIPTION:FAIL';
export const COMPANIES_INDUSTRIES_FETCH = 'COMPANIES:INDUSTRIES:FETCH';
export const COMPANIES_INDUSTRIES_FETCH_SUCCESS = 'COMPANIES:INDUSTRIES:FETCH_SUCCESS';
export const COMPANIES_INDUSTRIES_FETCH_FAIL = 'COMPANIES:INDUSTRIES:FETCH_FAIL';
export const COMPANIES_SIZES_FETCH = 'COMPANIES:SIZES:FETCH';
export const COMPANIES_SIZES_FETCH_SUCCESS = 'COMPANIES:SIZES:FETCH_SUCCESS';
export const COMPANIES_SIZES_FETCH_FAIL = 'COMPANIES:SIZES:FETCH_FAIL';
export const COMPANIES_COUNTRIES_FETCH = 'COMPANIES:COUNTRIES:FETCH';
export const COMPANIES_COUNTRIES_FETCH_SUCCESS = 'COMPANIES:COUNTRIES:FETCH_SUCCESS';
export const COMPANIES_COUNTRIES_FETCH_FAIL = 'COMPANIES:COUNTRIES:FETCH_FAIL';
export const COMPANIES_FONT_ADD = 'COMPANIES:FONT:ADD';
export const COMPANIES_FONT_ADD_FAIL = 'COMPANIES:FONT:ADD_FAIL';
export const COMPANIES_FONT_REMOVE = 'COMPANIES:FONT:REMOVE';
export const COMPANIES_FONT_REMOVE_FAIL = 'COMPANIES:FONT:REMOVE_FAIL';
export const COMPANIES_SMART_FIELDS_UPDATE = 'COMPANIES:SMART_FIELDS:UPDATE';
export const COMPANIES_SMART_FIELDS_UPDATE_FAIL = 'COMPANIES:SMART_FIELDS:UPDATE_FAIL';

export const COMPANIES_SETTING_WRITE = 'COMPANIES:SETTING_WRITE';
export const COMPANIES_SETTING_WRITE_SUCCESS = 'COMPANIES:SETTING_WRITE_SUCCESS';
export const COMPANIES_SETTING_WRITE_FAIL = 'COMPANIES:SETTING_WRITE_FAIL';

// WORKSPACE
export const WORKSPACE_VALIDATE = 'WORKSPACE:VALIDATE';
export const WORKSPACE_VALIDATE_SUCCESS = 'WORKSPACE:VALIDATE_SUCCESS';
export const WORKSPACE_VALIDATE_FAIL = 'WORKSPACE:VALIDATE_FAIL';
export const WORKSPACE_ADD = 'WORKSPACE:ADD';
export const WORKSPACE_ADD_SUCCESS = 'WORKSPACE:ADD_SUCCESS';
export const WORKSPACE_ADD_FAIL = 'WORKSPACE:ADD_FAIL';
export const WORKSPACE_UPDATE = 'WORKSPACE:UPDATE';
export const WORKSPACE_UPDATE_SUCCESS = 'WORKSPACE:UPDATE_SUCCESS';
export const WORKSPACE_UPDATE_FAIL = 'WORKSPACE:UPDATE_FAIL';
export const WORKSPACE_DELETE = 'WORKSPACE:DELETE';
export const WORKSPACE_DELETE_SUCCESS = 'WORKSPACE:DELETE_SUCCESS';
export const WORKSPACE_DELETE_FAIL = 'WORKSPACE:DELETE_FAIL';

// ERROR
export const ERROR_HANDLER_SET = 'ERROR_HANDLER:SET';
export const ERROR_HANDLER_RESET = 'ERROR_HANDLER:RESET';

// MODAL
export const MODAL_SHOW = 'MODAL:SHOW';
export const MODAL_HIDE = 'MODAL:HIDE';
export const MODAL_RESET = 'MODAL:RESET';

// FOLDERS
export const FOLDER_GET = 'FOLDER:GET';
export const FOLDER_GET_SUCCESS = 'FOLDER:GET_SUCCESS';
export const FOLDER_GET_FAIL = 'FOLDER:GET_FAIL';
export const FOLDER_SET_PARENT = 'FOLDER:SET_PARENT';

export const REMOVE_COMPANY_FOLDER = 'FOLDER:REMOVE_COMPANY_FOLDER';
export const REMOVE_COMPANY_FOLDER_SUCCESS = 'FOLDER:REMOVE_COMPANY_FOLDER_SUCCESS';
export const REMOVE_COMPANY_FOLDER_FAIL = 'FOLDER:REMOVE_COMPANY_FOLDER_FAIL';

export const FOLDER_ADD = 'FOLDER:FOLDER_ADD';
export const FOLDER_ADD_SUCCESS = 'FOLDER:FOLDER_ADD_SUCCESS';
export const FOLDER_ADD_FAIL = 'FOLDER:FOLDER_ADD_FAIL';

export const FOLDER_UPDATE = 'FOLDER:FOLDER_UPDATE';
export const FOLDER_UPDATE_SUCCESS = 'FOLDER:FOLDER_UPDATE_SUCCESS';
export const FOLDER_UPDATE_FAIL = 'FOLDER:FOLDER_UPDATE_FAIL';

export const FOLDER_DELETE = 'FOLDER:FOLDER_DELETE';
export const FOLDER_DELETE_SUCCESS = 'FOLDER:FOLDER_DELETE_SUCCESS';
export const FOLDER_DELETE_FAIL = 'FOLDER:FOLDER_DELETE_FAIL';

export const REQUEST_FINISHED = 'REQUEST:FINISHED';

// QUICK MESSAGES
export const QUICK_MESSAGE_ENQUEUE = 'QUICK_MESSAGE:ENQUEUE';
export const QUICK_MESSAGE_FADE = 'QUICK_MESSAGE:FADE';
export const QUICK_MESSAGE_DEQUEUE = 'QUICK_MESSAGE:REMOVE';

// PRELOADER
export const SHOW_PRELOADER = 'SHOW:PRELOADER';
export const HIDE_PRELOADER = 'HIDE:PRELOADER';

// CB PRELOADER
export const SHOW_CB_LOADER = 'SHOW:CB_LOADER';
export const HIDE_CB_LOADER = 'HIDE:CB_LOADER';

// PROCESSING ORDER
export const SHOW_PROCESSING_ORDER = 'SHOW:PROCESSING_ORDER';
export const HIDE_PROCESSING_ORDER = 'HIDE:PROCESSING_ORDER';

// EMAILS
export const SEND_EMAIL = 'SEND:EMAIL';
export const SEND_EMAIL_SUCCESS = 'SEND:EMAIL:SUCCESS';
export const SEND_EMAIL_FAIL = 'SEND:EMAIL:FAIL';

// TABS ON SUBSCRIPTION PAGE
export const SUBSCRIPTION_CATEGORY_SET = 'APP:SUBSCRIPTION_CATEGORY_SET';
export const SUBSCRIPTION_PERIOD_SET = 'APP:SUBSCRIPTION_PERIOD_SET';
export const SUBSCRIPTION_CURRENCY_SET = 'APP:SUBSCRIPTION_CURRENCY_SET';
export const SUBSCRIPTION_CLEAR_STATE = 'APP:SUBSCRIPTION_CLEAR_STATE';
export const SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED = 'APP:SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED';
export const SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED = 'APP:SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED';
export const SUBSCRIPTION_VIEW_SET = 'APP:SUBSCRIPTION_VIEW_SET';
export const SUBSCRIPTION_BATCH_PARAMS_SET = 'APP:SUBSCRIPTION_BATCH_PARAMS_SET';

// SEATS AND LICENSES QUANTITY
export const SEATS_QUANTITY_SET = 'APP:SEATS_QUANTITY_SET';
export const LICENSES_QUANTITY_SET = 'APP:LICENSES_QUANTITY_SET';

// REDUCE USERS
export const USER_REDUCE_UPDATE = 'USER:REDUCE:UPDATE';


// WEBPACK FOOTER //
// ./src/redux/modules/actions.js